// extracted by mini-css-extract-plugin
module.exports = {"search-form":"search-bar_search-form__S4_yP","active":"search-bar_active__JAXOH"};